import { useRef, useState } from "react";

export type ModalControls = {
  isModalOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
};
export function useModalControls(): ModalControls {
  const [isModalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  return { isModalOpen, openModal, closeModal };
}
export type AsyncModalControls<T> = {
  isModalOpen: boolean;
  openModal: () => Promise<T>;
  closeModal: (T) => void;
};
export function useAsyncModalControls<T>(): AsyncModalControls<T> {
  const [isModalOpen, setModalOpen] = useState(false);
  const resolveRef = useRef<((value: T) => void) | null>(null);

  function closeModal(res: T) {
    setModalOpen(false);

    if (resolveRef.current) {
      resolveRef.current(res);
      resolveRef.current = null;
    }
  }

  function openModal(): Promise<T> {
    const promise = new Promise<T>((resolve) => {
      resolveRef.current = resolve;
    });

    setModalOpen(true);

    return promise;
  }

  return { isModalOpen, openModal, closeModal };
}
